import * as actions from "actions";
import {
  // getClientCredential,
  getUsersSettings,
  saveUsersSettings,
  saveGeneralSettings,
  getTTPUser,
  saveUserAvatarToApi,
  getAvatarsAndUsers
} from "Api";
// import { pushSourceToken } from "utils";

export const fetchAuthor = authorId => {
  return (dispatch, getState) => {
    // let sourceToken = pushSourceToken("FETCH_AUTHOR", dispatch);

    const { token } = getState().auth;
    return dispatch(actions.setUsers(getTTPUser(authorId, token, 1)));
  };
};

export const fetchUsers = (
  page = 0,
  word = "",
  role = "ALL",
  communityId = null
) => {
  let operation =
    parseInt(page, 10) === 0 ? "initUsersForSettings" : "pushUsersForSettings";

  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;
    // let sourceToken = pushSourceToken("FETCH_USERS", dispatch);
    let organizationId = communityId || navCommunity.id;

    return dispatch(
      actions.setUsers(
        getUsersSettings(token, page, word, role, organizationId),
        operation
      )
    );
  };
};

export const fetchAvatarsAndUsers = (word = "", communityId = null) => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;
    // let sourceToken = pushSourceToken("FETCH_USERS", dispatch);
    let organizationId = communityId || navCommunity.id;

    return dispatch(
      actions.setAvatarsAndUsers(
        getAvatarsAndUsers(token, word, organizationId)
      )
    );
  };
};

export const updateUsersAvatar = (userId, avatar, rect) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.saveUserAvatar(saveUserAvatarToApi(token, userId, avatar, rect))
    );
  };
};

export const updateUsersSettings = ({ languages, types, usersIds }) => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;

    return dispatch(
      actions.saveUsers(
        saveUsersSettings({
          token,
          community: navCommunity,
          types,
          languages,
          usersIds
        }).then(res =>
          dispatch(
            actions.updateUsers({
              community: navCommunity,
              types,
              languages,
              usersIds
            })
          )
        )
      )
    );
  };
};

export const updateGeneralSettings = ({
  languages,
  generalTypes,
  publicProfile,
  defaultData
}) => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;

    return dispatch(
      actions.saveGeneralSettings(
        saveGeneralSettings({
          token,
          community: navCommunity,
          generalTypes,
          languages,
          publicProfile,
          defaultData
        }).then(res =>
          dispatch(
            actions.updateGeneralSettings({
              community: navCommunity,
              generalTypes,
              languages,
              publicProfile,
              defaultData
            })
          )
        )
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/users.js